// Entry der oeffentlichen Seiten (themes/mybrunex/layout/auth.html.twig):
// Login, Registrierung, Passwort zuruecksetzen. Ein Entry fuer das ganze
// Layout; was nur eine Seite braucht, kommt als eigener Chunk nach, sobald das
// Markup dafuer da ist. Die Skripte laufen mit defer (webpack_encore.yaml),
// das DOM steht also beim Start.
import '../styles/auth.scss';
import './auth/login';

// Registrierung, Schritt 2: durchsuchbare Auswahlfelder (Tom Select) — die
// Felder tragen data-autocomplete (RegistrationAddressType, RegistrationUserType).
if (document.querySelector('select[data-autocomplete]')) {
  import(/* webpackChunkName: "autocomplete" */ './auth/autocomplete');
}
